import { motion } from "framer-motion";
import { useReducedMotion } from "../../hooks/useReducedMotion";

function Reveal({ as = "div", delay = 0, y = 24, children, ...rest }) {
  const reduced = useReducedMotion();
  const Component = motion[as] || motion.div;

  if (reduced) {
    const MotionlessTag = as;
    return <MotionlessTag {...rest}>{children}</MotionlessTag>;
  }

  return (
    <Component
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay }}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default Reveal;
